module.exports = __webpack_public_path__ + "me_big.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/me_big.png
// module id = 30
// module chunks = 0